import { FunctionComponent, lazy, Fragment } from 'react'
import { Switch, Route } from 'react-router-dom'

const SendAttachment = lazy(
  () =>
    import(
      '@/modules/Attachment/submodules/MedicalAttachment/pages/SendAttachment'
    ),
)

const ReferralInformation = lazy(
  () =>
    import(
      '@/modules/Attachment/submodules/MedicalAttachment/pages/ReferralInformation'
    ),
)

const ReviewRequestData = lazy(
  () =>
    import(
      '@/modules/Attachment/submodules/MedicalAttachment/pages/ReviewRequestData'
    ),
)

const ConfirmationSending = lazy(
  () =>
    import(
      '@/modules/Attachment/submodules/MedicalAttachment/pages/ConfirmationSending'
    ),
)

const DocumentList = lazy(
  () => import('@/modules/Attachment/submodules/Documents/pages/DocumentList'),
)

const DocumentHistory = lazy(
  () =>
    import('@/modules/Attachment/submodules/Documents/pages/DocumentHistory'),
)

const DocumentDetails = lazy(
  () =>
    import('@/modules/Attachment/submodules/Documents/pages/DocumentDetails'),
)

const routes = [
  <Route path="/documentos" key="/documentos" exact component={DocumentList} />,
  <Route
    path="/documentos/historico/:documentId"
    key="/documentos/historico/:documentId"
    exact
    component={DocumentHistory}
  />,
  <Route
    path="/documentos/detalhes/:documentId"
    key="/documentos/detalhes/:documentId"
    exact
    component={DocumentDetails}
  />,
  <Route
    path="/documentos/encaminhamento-medico/anexar"
    key="/documentos/encaminhamento-medico/anexar"
    exact
    component={SendAttachment}
  />,
  <Route
    path="/documentos/encaminhamento-medico/informacoes-do-encaminhamento"
    key="/documentos/encaminhamento-medico/informacoes-do-encaminhamento"
    exact
    component={ReferralInformation}
  />,
  <Route
    path="/documentos/encaminhamento-medico/revisar-dados"
    key="/documentos/encaminhamento-medico/revisar-dados"
    exact
    component={ReviewRequestData}
  />,
  <Route
    path="/documentos/encaminhamento-medico/enviado-com-sucesso/:documentId"
    key="/documentos/encaminhamento-medico/enviado-com-sucesso/:documentId"
    exact
    component={ConfirmationSending}
  />,
]

const AttachmentRoutes: FunctionComponent = () => (
  <Fragment>
    <Switch>{routes}</Switch>
  </Fragment>
)

export default AttachmentRoutes
